var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtiqueta1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 514.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a58c70;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.61,334.37c-26.18,12.77-59.57,17.35-89.03,17.35C51.49,351.71.75,312.1.75,257.44s50.42-94.93,135.85-94.93c27.83,0,63.18,4.26,90.02,17.67v39.94c-14.73-6.22-44.52-18.66-87.07-18.66-63.84,0-89.69,27.82-89.69,55.65s24.88,55.64,90.67,55.64c45.83,0,74.96-13.42,86.09-18.33v39.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.89,348.44v-74.63h-128.32v74.63h-45.82v-182.66h45.82v68.74h128.32v-68.74h45.83v182.66h-45.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.65,348.44v-182.66h45.82v182.66h-45.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M799.07,348.44l-40.59-57.94h-59.9v57.94h-46.15v-182.66h129.3c52.05,0,67.76,38.96,67.76,62.2,0,17.67-10.81,43.86-41.9,55.97l44.52,64.49h-53.03ZM698.58,205.06v46.15h71.36c26.18,0,31.42-14.73,31.42-23.24s-5.24-22.91-31.42-22.91h-71.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M876.96,348.44l114.57-143.7h-109v-38.96h192.8l-114.24,143.71h118.17v38.95h-202.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtiqueta1);
export default __webpack_public_path__ + "static/media/etiqueta1.3b7136b1cb42f756fdd1e7a96aac3021.svg";
export { ForwardRef as ReactComponent };